import { createContext, useContext, useState, useCallback } from "react";
import { content } from "@/i18n/content";

const LanguageContext = createContext(null);

const LANGS = ["en", "hi", "hinglish"];

const initialLang = () => {
  if (typeof window !== "undefined") {
    const p = new URLSearchParams(window.location.search).get("lang");
    if (LANGS.includes(p)) return p;
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);

  const toggle = useCallback(() => {
    setLang((prev) => LANGS[(LANGS.indexOf(prev) + 1) % LANGS.length]);
  }, []);

  const t = content[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      <div className={lang === "hi" ? "lang-hi" : "lang-en"}>{children}</div>
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
